import classes from './finish-styles.module.css'
const FinishMessage = (props) => {
    return (
        <div className={classes.container}>
            <div className={classes.innerContainer}>
                <div className={classes.message}>
                    <div >We hope you had some fun but don’t forget our main goal is to help you thicken your compliance knowledge so Here is the link to our SOP if you want to take a deeper look! References for each question:
                    </div>
                    <div className={classes.rows}>
                        <div>MEA code 2021</div>
                        <div>Onboarding slide deck</div>
                        <div>Country requirements website</div>
                    </div>
                    <a className={classes.clickMeButton} href="https://amgen.sharepoint.com/sites/hccrequir-240157/FormServerTemplates/Country%20Requirements%20Overview.aspx" target="_blank" rel="noreferrer noopener">

                    </a>
                </div>
            </div>
        </div>
    )
}
export default FinishMessage